export default function generateLinkJob(propsAlias: string, propsJobId: string, language: string, utmString: string = '') {
    let linkJob = process.env.VNW_BASE_URL + '/' + propsAlias + '-' + propsJobId

    if (language === 'en') {
        linkJob += '-jd'
    } else {
        linkJob += '-jv'
    }

    if (utmString.length > 0) {
        linkJob += '?' + utmString
    }

    return linkJob
}
